// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ValidateFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import translate from "@insite/client-framework/Translate";
import { UserSetupValidationRules } from "@werner/XDL/constants";

/**
 *
 * Validate firstname, lastname & email with min & max characters based on ApendixA on Confluence
 * @param props
 * @returns
 */
export const XngValidateFields: typeof ValidateFields = props => {
    const { parameter, result } = props;
    // MAX-Character length Check
    if (typeof parameter.email !== "undefined" && parameter.email?.length > UserSetupValidationRules.email.maxLength) {
        result.emailErrorMessage = translate(
            "Email Address must be at most {0} characters long",
            UserSetupValidationRules.email.maxLength.toString(),
        );
    }
    if (
        typeof parameter.firstName !== "undefined" &&
        parameter.firstName?.length < UserSetupValidationRules.firstName.minLength
    ) {
        result.firstNameErrorMessage = translate(
            "First Name must be at least {0} character long",
            UserSetupValidationRules.firstName.minLength.toString(),
        );
    }

    if (
        typeof parameter.lastName !== "undefined" &&
        parameter.lastName?.length < UserSetupValidationRules.lastName.minLength
    ) {
        result.lastNameErrorMessage = translate(
            "Last Name must be at least {0} character long",
            UserSetupValidationRules.lastName.minLength.toString(),
        );
    }
    if (
        typeof parameter.firstName !== "undefined" &&
        parameter.firstName?.length > UserSetupValidationRules.firstName.maxLength
    ) {
        result.firstNameErrorMessage = translate(
            "First Name must be at most {0} characters long",
            UserSetupValidationRules.firstName.maxLength.toString(),
        );
    }

    if (
        typeof parameter.lastName !== "undefined" &&
        parameter.lastName?.length > UserSetupValidationRules.lastName.maxLength
    ) {
        result.lastNameErrorMessage = translate(
            "Last Name must be at most {0} characters long",
            UserSetupValidationRules.lastName.maxLength.toString(),
        );
    }
};

addToChainAfter(chain, ValidateFields, XngValidateFields);
